import React, { createContext, useContext } from 'react';

interface ReportActions {
    onSave: () => void;
    onDownloadPdf: () => void;
    isSaving: boolean;
    hasCustomSave: boolean;
    customSaveLabel?: string;
    readOnly: boolean;
}

const ReportActionsContext = createContext<ReportActions | null>(null);

export const ReportActionsProvider = ReportActionsContext.Provider;

export function useReportActions() {
    return useContext(ReportActionsContext);
}
